// @flow
import { CheckBoxField } from '@src/formik-utils/FormFields';
import React, { useContext } from 'react';
import { useUpdateSPOrgMutation } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { SPOrgContext } from '@streaming-projects/orgs/contexts/SPOrgContext';
import { useParams } from 'react-router-dom';
import { toastError } from '@presentational/notifications/utils';
import { CUSTOMER_VIEW_ENUMS } from '@streaming-projects/orgs/enums';

export const SPOrgCustomerViewContainer = () => {
  const { orgId } = useParams();
  const [updateSPOrgDetails] = useUpdateSPOrgMutation();
  const spOrgData = useContext(SPOrgContext);
  const entityVersion = spOrgData?.org?.version;

  return (
    <CheckBoxField
      fieldDisplayName={CUSTOMER_VIEW_ENUMS.DISPLAY_NAME}
      fieldName={CUSTOMER_VIEW_ENUMS.BACKEND_NAME}
      onChange={async (event, value, setFieldValue, setFieldTouched, values, checked) => {
        const payload = {
          [CUSTOMER_VIEW_ENUMS.BACKEND_NAME]: checked,
          org_id: orgId,
          entity_version: entityVersion,
          account_id: spOrgData?.org?.account_id,
          account_name: spOrgData?.org?.account_name,
          sfdc_org_id: spOrgData?.org?.sfdc_org_id,
          sfdc_org_name: spOrgData?.org?.sfdc_org_name,
          rate_card: spOrgData?.org?.rate_card,
        };

        const { error } = await updateSPOrgDetails({
          orgId: orgId,
          payload,
        });

        if (error) {
          toastError(error);
        }
      }}
    />
  );
};
